<!-- <div class="col-md-4 col-11"> -->
    <div class="coursdetl-tutrexprt-bx">
        <div class="tutr-title">
            <img class="tutr-title-icon" src="assets/img/assessment/streak-icon.svg" /><span>{{expertiseData?.title}}</span>
        </div>
        <p class="tutr-para">{{expertiseData?.description}}</p>
    </div>
<!-- </div> -->